import axios from 'axios';
import CdnMixin from '@SHARED/js/Vue/mixins/CdnMixin';
import template from './MetaDataComponent.html';

export default {
  template,

  mixins: [CdnMixin],

  props: {
    entityType: {
      type: String,
      required: true,
    },

    entityId: {
      type: Number,
      required: true,
    },

    entityMeta: {
      type: Object,
      default() {
        return null;
      },
    },
  },

  data() {
    return {
      params: {
        title: '',
        description: '',
        canonical: '',
        og_description: '',
        metaable_id: this.entityId || null,
        metaable_type: this.entityType || null,
      },
      metaInstanceId: null,
      ogImageMedia: null,
      userFeedback: '',
      errors: {},
      unsavedDataMessage: '',
      isLoading: false,
    };
  },

  computed: {
    descriptionLength() {
      if (this.params.description) {
        return this.params.description.length;
      }

      return 0;
    },
  },

  mounted() {
    if (this.entityMeta) {
      this.populateParams();
      this.metaInstanceId = this.entityMeta.id;

      if (typeof this.entityMeta.meta_images !== 'undefined' && this.entityMeta.meta_images.length) {
        this.ogImageMedia = this.entityMeta.meta_images[0];
      }
    } else {
      this.unsavedDataMessage = 'Du har ikke opprettet meta data for denne siden ennå.';
    }
  },

  watch: {
    'params.title': function (value) {
      if (this.entityMeta) {
        if (value !== this.entityMeta.title) {
          this.unsavedDataMessage = 'Du har ulagret data.';
        }
      }
    },

    'params.description': function (value) {
      if (this.entityMeta) {
        if (value !== this.entityMeta.description) {
          this.unsavedDataMessage = 'Du har ulagret data.';
        }
      }
    },

    'params.og_description': function (value) {
      if (this.entityMeta) {
        if (value !== this.entityMeta.og_description) {
          this.unsavedDataMessage = 'Du har ulagret data.';
        }
      }
    },
    isLoading(val) {
      if (val === true) {
        window.loader.show();
      } else {
        window.loader.hide();
      }
    },
  },

  methods: {
    storeOrUpdate() {
      // Was already submitted?
      if (this.isLoading) return;

      this.errors = {};
      this.userFeedback = '';
      this.isLoading = true;

      axios.post('/admin/api/v1/meta', Object.assign({}, this.params, { id: this.metaInstanceId }))
        .then((response) => {
          this.metaInstanceId = response.data.meta.id;
          this.userFeedback = response.data.message;
          this.unsavedDataMessage = '';
          this.isLoading = false;
        })
        .catch((error) => {
          this.errors = error.response.data.errors;
          this.isLoading = false;
        });
    },

    populateParams() {
      this.params.title = this.entityMeta.title;
      this.params.description = this.entityMeta.description;
      this.params.canonical = this.entityMeta.canonical;
      this.params.og_description = this.entityMeta.og_description;
      this.unsavedDataMessage = '';
    },
    ogImageUpdated(data) {
      this.ogImageMedia = data;
    },
  },
};
